import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import StockManager from '../../components/Admin/StockManager';
import { Shield } from 'lucide-react';

// Liste des emails autorisés pour l'administration
const ADMIN_EMAILS = ['comprendrelessespro@gmail.com'];

const AdminPage = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Vérifier si l'utilisateur est connecté et autorisé
    if (!currentUser) {
      navigate('/auth/signin');
      return;
    }

    // Vérifier si l'email de l'utilisateur est dans la liste des administrateurs
    if (!ADMIN_EMAILS.includes(currentUser.email || '')) {
      navigate('/');
      return;
    }
  }, [currentUser, navigate]);

  // Si l'utilisateur n'est pas connecté ou n'est pas administrateur, ne rien afficher
  if (!currentUser || !ADMIN_EMAILS.includes(currentUser.email || '')) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <main className="pt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="flex items-center gap-4 mb-8">
            <div className="w-12 h-12 bg-[#9a6ebd]/10 rounded-full flex items-center justify-center">
              <Shield className="text-[#9a6ebd]" size={24} />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-[#323c5f]">
                Administration
              </h1>
              <p className="text-gray-600">
                Gérez votre site et vos produits
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <StockManager />
            
            {/* Autres composants d'administration peuvent être ajoutés ici */}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AdminPage;